import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=a2f16724&scoped=true"
import script from "./back-to-top.vue?vue&type=script&lang=js"
export * from "./back-to-top.vue?vue&type=script&lang=js"
import style0 from "./back-to-top.vue?vue&type=style&index=0&id=a2f16724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f16724",
  null
  
)

export default component.exports